export interface SlideBox {
	left: number;
	width: number;
}

const centerOf = ({ left, width }: SlideBox) => left + width / 2;

export const getNearestSlide = (slides: SlideBox[], scrollLeft: number, viewWidth: number) => {
	const viewCenter = scrollLeft + viewWidth / 2;
	let nearest = 0;
	slides.forEach((slide, index) => {
		if (Math.abs(centerOf(slide) - viewCenter) < Math.abs(centerOf(slides[nearest]) - viewCenter)) nearest = index;
	});
	return nearest;
};

export const getSlideScrollLeft = (slide: SlideBox, viewWidth: number) => centerOf(slide) - viewWidth / 2;
